<div class="app-divider-dropdown-container" #dividerDropdownContainer>

  <div [class]="styleClass" (click)="showDropdown()">
    <div class="btn-text" id="app-divider-dropdown-text-btn font-bold font-13">
      <span class="font-13">{{text}}</span>
    </div>
    <div class="btn-divider-bar">
      <i class="fal fa-chevron-down" id="app-divider-dropdown-icon-up" [hidden]="isDropDownVisible"></i>
      <i class="fal fa-chevron-up" id="app-divider-dropdown-icon-down" [hidden]="!isDropDownVisible"></i>
    </div>
  </div>
  <div class="dropdown-cotent" [ngClass]="{
    'display-block': isDropDownVisible,
    'display-none': !isDropDownVisible
    }">
    <ng-container *ngTemplateOutlet="overlayTemplate; context: {close: closeDropdown}">
    </ng-container>
  </div>

</div>
